import { WorkspaceChatCard } from "@components/shared/workspace/Workspace";
import WebsiteChat from "./WebsiteChat";

/**
 * Sidebar for the website build step — just the live website chat. The
 * WorkflowBuddy + locked-chat treatment that used to wrap the standalone
 * /domain step went away when the domain picker moved inline onto build.
 */
export default function WebsiteSidebar() {
  return (
    <WorkspaceChatCard>
      <WebsiteChat />
    </WorkspaceChatCard>
  );
}
